import React, { type ComponentPropsWithoutRef, useState } from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors } from '@mobi/component-library/Foundations'
import { Input } from './Input'

type Props = Omit<ComponentPropsWithoutRef<typeof Input>, 'type' | 'suffix'>

export const Password = (props: Props) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false)

  const type = isPasswordVisible ? 'text' : 'password'

  const renderSuffix = () => (
    <UnstyledButton
      style={{ height: '100%' }}
      type='button'
      onClick={() => setPasswordVisible(isVisible => !isVisible)}
    >
      <Icon name={isPasswordVisible ? 'LineEye' : 'LineEyeOff'} color={colors.black} />
    </UnstyledButton>
  )

  return <Input type={type} {...props} suffix={renderSuffix()} />
}

Password.displayName = 'Password'

// ======
// Styles
// ======

const UnstyledButton = styled.button([
  {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: 1.15,
    margin: 0,
    textTransform: 'none',
    WebkitAppearance: 'button',
    background: 'none',
    border: 'none',
    padding: 0,
  },
])
